import React from "react";
import { useForm } from "react-hook-form";
import { queryString, safeAwait } from "@coninsa/utils";

import { Button, toast } from "@coninsa/core";
import { createNuwweDocuments, logoutUser } from "../api";

type T_props = {
  onSuccess: () => void;
  onBack: () => void;
};

type T_fields = {
  document: FileList;
  freedom_certificate: FileList;
  without_documents: boolean;
};

function Step5({ onSuccess, onBack }: T_props) {
  const {
    formState: { isSubmitting },
    handleSubmit,
    register,
    watch,
  } = useForm<T_fields>({
    defaultValues: async () => {
      const values = JSON.parse(
        localStorage.getItem("consignation.documents") ?? "{}"
      );

      return values;
    },
  });

  const withoutDocuments = watch("without_documents");

  const onSubmit = async (data) => {
    localStorage.setItem("consignation.documents", JSON.stringify(data));
    localStorage.removeItem("consignation.user");
    localStorage.removeItem("consignation.client");
    localStorage.removeItem("consignation.property");
    localStorage.removeItem("consignation.distribution");
    localStorage.removeItem("consignation.images");
    localStorage.removeItem("consignation.documents");

    await safeAwait(logoutUser());

    onSuccess();

    if (withoutDocuments) {
      onSuccess();
      return;
    }

    const code = queryString.get("property");
    const body = new FormData();
    body.append("document", data.document[0]);
    body.append("freedom_certificate", data.freedom_certificate[0]);
    body.append("without_documents", data.without_documents);

    if (code) {
      try {
        const response = await createNuwweDocuments(code, body);

        toast.success({ message: "Documentos del cliente adicionados." });
        onSuccess();
      } catch (error) {
        toast.error({ message: "Algo salió mal." });
      }
    } else {
      toast.error({ message: "El código del cliente no está definido." });
    }
  };

  return (
    <div className="co-card max-w-4xl mx-auto">
      <h3 className="font-bold">Tarifas de administración y documentación</h3>
      <p className="mb-4">
        Un agente especializado se pondrá en contacto contigo para explicarte
        las tarifas y opciones de amparo adicionales. Así, podrás estar
        tranquilo en todo momento y contar con un servicio integral que cubra
        todos los aspectos de tu inmueble. ¡Arrendamos tu propiedad con total
        tranquilidad!
      </p>
      <p className="mb-6">
        Todas las tarifas están sujetas a IVA. Además, la duración de la
        garantía del arrendamiento se determinará durante el estudio del cliente
        arrendatario realizado por la aseguradora, con un período de cobertura
        que va de 6 a 36 meses por posibles moras.
      </p>
      <form className="co-form gap-y-8" onSubmit={handleSubmit(onSubmit)}>
        <div className="form-control">
          <label htmlFor="document">Adjuntar cédula de ciudadania</label>
          <input
            className="border border-s2-gray-300 p-2 rounded-md"
            type="file"
            id="document"
            {...register("document")}
          />
        </div>
        <div className="form-control">
          <label htmlFor="freedom_certificate">
            Adjuntar certificado de tradición y libertad (con una vigencia
            inferior de un año)
          </label>
          <input
            className="border border-s2-gray-300 p-2 rounded-md"
            type="file"
            id="freedom_certificate"
            {...register("freedom_certificate")}
          />
        </div>
        <div className="form-control is-checkbox bg-gray-100 p-3">
          <input
            type="checkbox"
            id="without_documents"
            {...register("without_documents")}
          />
          <label htmlFor="without_documents" className="data-policy">
            No cuento con los documentos en el momento, deseo hacerlo con un
            agente.
          </label>
        </div>

        <div className="flex justify-between gap-2 md:flex-row">
          <Button
            type="button"
            onClick={onBack}
            className="co-button is-secondary is-large has-fixed-icon"
          >
            <i className="co-icon icon-arrow"></i>
            Regresar
          </Button>

          <Button
            loading={isSubmitting}
            className="co-button is-progress-default is-large w-full md:w-auto"
          >
            Continuar
          </Button>
        </div>
      </form>
    </div>
  );
}

export default Step5;
